/*constants*/
export const STRONG_PASSWORD_REGEX = new RegExp(
  "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{6,})"
);
export const REGEX_IMAGE = /\.(jpg|jpeg|png|gif|bmp|webp|ico|JPG|JPEG|PNG|GIF|BMP|WEBP|ICO)$/;

export const ERROR = "error";
export const SUCCESS = "success";
export const NUMBER_CHARACTER = 60;

export const lists =[
  {name:"",type:[]},
  {name:"Agency",type:["","Recruitment agency","Staffing agency","Travel agency"]},
  {name:"Agronomie",type:["","Animal production","Food production","Food Quality Manager"]},
  {name:"Computer",type:["","Computer repairer","Cyber","Infographic","Digital services company"]},
  {name:"Business",type:["","Car sales","Land sale","Land House"]},
  {name:"Restoration",type:["Casual dining","Fast food","Ghost kitchens","Pizzerias"]}
]

export const LAWER_FORMS =[
  "",
  "SARL",
  "SARL and EURL",
  "SAS",
  "SASU"
]
export const MANAGEMENT_STYLES=[
  "",
  "Autocratic",
  "Democratic",
  "Laissez-faire",
  "Interview questions"
]
export const STRUCTURES=[
"",
"Hierarchical structure",
"Matrix structure",
"Network structure"
]
export const BANK=[
"",
"Acces Banque",
"BOA",
"BFV",
"BMOI",
"MCB"
]

export const FONT_AWESOME =[
"fas fa-bread-slice" ,
"fas fa-hamburger ",
"fas fa-pizza-slice",
"fas fa-cat",
"fas fa-dog",
"fas fa-rss",
"fas fa-headphones",
"fas fa-car-alt",
"fas fa-bus", 
"fas fa-gas-pump",
"fas fa-mug-hot",
"fas fa-glass-cheers",
"fas fa-home",
"fas fa-book",
"fas fa-pen-alt",
"fas fa-wallet",
"fas fa-donate",
"fas fa-dollar-sign",
"fas fa-hand-holding-usd",
"fas fa-video",
"fas fa-phone",
"fas fa-tshirt",
"fas fa-microphone",
"fas fa-wifi",

"fas fa-hdd",
"fas fa-desktop",
"fas fa-print",
"fas fa-server",

"fas fa-tablet",
"fas fa-mobile",

"fas fa-tools",

"fas fa-calendar-alt",

"fas fa-plug",
"fas fa-plane",
"fas fa-chart-line"
]

export const COLORS=[
  "#824DFF",
    "#3291E8",
    
    "#FCC13D",
    "#FA8B2B",
    "#F74871",
    "#93D6D5",
    "#FCBE89",
    "#E58C40",
    "#F74872",

    "#CA1B1B",
    "#0A6AC0",
    "#0493B4",
    "#00A0E2",


    "#39DE54",
    "#F09001",
    "#8AC2D9",
    "#BEC0C4",

    "#8C0375",
    "#F2059F",
    "#F97C93",
    "#F18DB1",
    "#F2D5EB",


    "#70D7EE",
    "#0BC1C1",



    "#CD26A8",
    "#9E54CB",
    "#15A05F",
    "#80CF1B",
    "#FFE457",


    "#FEB528",
    "#BD601D",
    "#63C798",
    "#BFA0FF",
    "#BB65D9"
]

 export const Dimensions = [
  {
    name: 'A0',
    width: '841mm',
    height: '1189mm'
  },
  {
    name: 'A1',
    width: '594mm',
    height: '841mm'
  },
  {
    name: 'A2',
    width: '420mm',
    height: '594mm'
  },
  {
    name: 'A3',
    width: '297mm',
    height: '420mm'
  },
  {
    name: 'A4',
    width: '210mm',
    height: '297mm'
  },
  {
    name: 'A5',
    width: '148mm',
    height: '210mm'
  },
  {
    name: 'A6',
    width: '105mm',
    height: '148mm'
  },
  {
    name: 'A7',
    width: '74mm',
    height: '105mm'
  },
  {
    name: 'A8',
    width: '52mm',
    height: '74mm'
  },
  {
    name: 'A9',
    width: '37mm',
    height: '52mm'
  },
  {
    name: 'A10',
    width: '26mm',
    height: '37mm'
  }
]